import { type TAdFoxBannerCompleteSizes } from '@cian/adfox-component';
import { type TTgbNativedescGeneralContext } from '@cian/adfox-templates';

import type { IBannerEnrichments } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';

import type { TTgbNativedescGeneralNarrowProps } from '../components/TgbNativedescGeneralNarrow';

type TGetTgbNativedescGeneralNarrowPropsParams = {
  context: TTgbNativedescGeneralContext;
  bannerEnrichment: null | IBannerEnrichments;
  sizes: TAdFoxBannerCompleteSizes;
};

export function getTgbNativedescGeneralNarrowProps({
  sizes,
  context: { url, label, image, title, annotation, description, logoImageUrl, mortgageTermsWarning, mortgageWarning },
  bannerEnrichment,
}: TGetTgbNativedescGeneralNarrowPropsParams): TTgbNativedescGeneralNarrowProps {
  const tgbNativedescGeneralProps = {
    annotation,
    description,
    image,
    label,
    logoUrl: logoImageUrl,
    title,
    url,
    mortgageTermsWarning,
    mortgageWarning,
    sizes,
  };

  if (bannerEnrichment) {
    Object.assign<TTgbNativedescGeneralNarrowProps, Partial<TTgbNativedescGeneralNarrowProps>>(
      tgbNativedescGeneralProps,
      {
        logoUrl: bannerEnrichment.publisher.logo.url,
      },
    );
  }

  return tgbNativedescGeneralProps;
}
